module.exports = __webpack_public_path__ + "img/footer.9802ce0c.png";